import { jsx } from 'react/jsx-runtime';
import { createContext, useState } from 'react';
import { THEMES } from '../global/constants/index.js';

const initialSettings = {
    direction: 'ltr',
    responsiveFontSizes: true,
    apiUrl: '',
    cdnUrl: '',
    cdnKey: '1',
    apmMonitorUrl: '',
    theme: THEMES.CIGAM,
    themes: '',
    portalBpmUrl: '',
    activePortals: [],
    defaultLogin: 'cigam',
    pdUrl: '',
    biUrl: '',
};
const storeSettings = (settings) => {
    localStorage.setItem('settings', JSON.stringify(settings));
};
const SettingsContext = createContext({
    settings: initialSettings,
    saveSettings: () => { },
});
const SettingsProvider = ({ settings, children, }) => {
    const [currentSettings, setCurrentSettings] = useState(settings || initialSettings);
    const saveSettings = (updatedSettings) => {
        setCurrentSettings(updatedSettings);
        storeSettings(updatedSettings);
    };
    return (jsx(SettingsContext.Provider, Object.assign({ value: {
            settings: currentSettings,
            saveSettings,
        } }, { children: children })));
};
const SettingsConsumer = SettingsContext.Consumer;

export { SettingsConsumer, SettingsContext, SettingsProvider, storeSettings };
